import React from "react";
import AsyncSelect from "../AsyncSelect";

const PlatformSelect = props => {
  const loadPath = 'platforms';

  const formatOptions = (options) => (
    (options || []).map(option =>
      ({label: option.name, value: {id: option.id, name: option.name}}))
  );

  const getOptionValue = (option) => option.value.id;

  return <AsyncSelect {...{ ...props, getOptionValue, formatOptions, loadPath }} />;
};

export default PlatformSelect;
